import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Dynamic Canonical Tag Component with Manual DOM Manipulation
const Canonical = () => {
  const location = useLocation();
  const canonicalUrl = `https://tavloai.com${location.pathname}`;

  // Debug log to check if component is rendering
  console.log("Canonical component rendering with URL:", canonicalUrl);

  useEffect(() => {
    console.log("Canonical useEffect triggered for:", canonicalUrl);
    
    // Remove existing canonical tag if it exists
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
      console.log("Removed existing canonical tag");
    }

    // Create new canonical tag
    const canonicalTag = document.createElement('link');
    canonicalTag.rel = 'canonical';
    canonicalTag.href = canonicalUrl;
    
    // Add to document head
    document.head.appendChild(canonicalTag);
    console.log("Added canonical tag to DOM:", canonicalTag);
    
    // Verify it was added
    const verifyTag = document.querySelector('link[rel="canonical"]');
    console.log("Verification - canonical tag in DOM:", verifyTag);
    if (verifyTag) {
      console.log("Verification - canonical href:", verifyTag.href);
    }

    // Cleanup function to remove tag when component unmounts
    return () => {
      const tagToRemove = document.querySelector('link[rel="canonical"]');
      if (tagToRemove) {
        tagToRemove.remove();
      }
    };
  }, [canonicalUrl]);

  return null; // This component doesn't render anything visible
};

export default Canonical;
